import { IHttpApi } from '@cian/http-api';
import {
  fetchGetPaymentWidgetMethods,
  IMappers,
} from '../../../repositories/billing-payments/v1/get-payment-widget-methods';
import { DEFAULT_RESULT } from './constants';
import { mapResponse200 } from './utils';
import { EPaymentInitSource } from '../../../types/redux/checkout';
import { IGetPaymentMethodsResult } from './types';

interface IParams {
  httpApi: IHttpApi;
  paymentInitSource: EPaymentInitSource;
}

export const getPaymentMethods = async (params: IParams): Promise<IGetPaymentMethodsResult> => {
  const { httpApi, paymentInitSource } = params;

  const parameters = {
    paymentInitSource,
  };

  const mappers: IMappers<IGetPaymentMethodsResult> = {
    200: mapResponse200,
  };

  try {
    const response = await fetchGetPaymentWidgetMethods({ httpApi, parameters, mappers });

    return response as IGetPaymentMethodsResult;
  } catch {
    return DEFAULT_RESULT;
  }
};
